import { getLocalStorageData } from '../../../utils/helper';
import { APP_API_URL_V2 } from '../../../utils/xhr-instance';
import { axiosInstanceV2 } from '../../axios';

export async function getProductGeneral() {
	const API_URL = `${APP_API_URL_V2}/settings/inventory/products/general`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response?.data);
}

export async function UpdateProductGeneral(data) {
	const API_URL = `${APP_API_URL_V2}/settings/inventory/products/general`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}

export async function getPackagingGeneral(params) {
	const API_URL = `${APP_API_URL_V2}/settings/inventory/packaging`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response?.data);
}

export async function createPackagingGeneral(data) {
	const API_URL = `${APP_API_URL_V2}/settings/inventory/packaging`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.post(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}

export async function UpdatePackagingGeneral(id, data) {
	const API_URL = `${APP_API_URL_V2}/settings/inventory/packaging/${id}`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}
export async function UpdatePackagingGeneralStatus(id, data) {
	const API_URL = `${APP_API_URL_V2}/settings/inventory/packaging/${id}/status`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.patch(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}
export async function deletePackagingGeneral(id) {
	const API_URL = `${APP_API_URL_V2}/settings/inventory/packaging/${id}`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.delete(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}

export async function getMeasuringUnitGeneral(params) {
	const API_URL = `${APP_API_URL_V2}/settings/inventory/measuring-units`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response?.data);
}

export async function createMeasuringUnitGeneral(data) {
	const API_URL = `${APP_API_URL_V2}/settings/inventory/measuring-units`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.post(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}

export async function UpdateMeasuringUnitGeneral(id, data) {
	const API_URL = `${APP_API_URL_V2}/settings/inventory/measuring-units/${id}`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}
export async function UpdateMeasuringUnitGeneralStatus(id, data) {
	const API_URL = `${APP_API_URL_V2}/settings/inventory/measuring-units/${id}/status`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.patch(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}
export async function deleteMeasuringUnitGeneral(id) {
	const API_URL = `${APP_API_URL_V2}/settings/inventory/measuring-units/${id}`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.delete(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}
